/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useRef, useCallback, useMemo } from "react";
import LogicContext from "../../Context/LogicContext";
import { GetDriverAssignList, SetDriverAssignList } from "../../store/driverAssignAtom";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdRefresh } from "react-icons/io";
import { useForm } from "react-hook-form";
import moment from "moment";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { driverAssignService } from "../../services/driverAssignService";

const DriverAssignPage = () => {
  const { pathname } = useLocation();
  const { register, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();
  const navigate = useNavigate();
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const { showToast, httpResponseManager } = useContext(LogicContext); // Select only needed context value
  const setDriverAssignData = SetDriverAssignList();
  const driverAssignData = GetDriverAssignList();
  const myPromiseModal = createModal(GeneralModal);
  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const mountRef = useRef(false);
  const [searchText, setSearchText] = useState("");


  // Memoized columns to prevent recreation
  const columns = useMemo(
    () => [
      {
        title: "Reference",
        key: "sales_order_ref_no",
        dataIndex: "sales_order_ref_no",
        className: "text-primary",
        sorter: (a, b) => (a?.sales_order_ref_no ?? "") - (b?.sales_order_ref_no ?? ""),
      },
      {
        title: "Order Date",
        dataIndex: "sales_order_date",
        sorter: (a, b) => (a?.sales_order_date ?? "").localeCompare(b?.sales_order_date ?? ""),
        render: (value) => (value ? moment(value).format("DD-MM-YYYY") : ""),
      },
      {
        title: "Order Number",
        dataIndex: "sales_order_no",
        sorter: (a, b) => (a?.sales_order_no ?? "").localeCompare(b?.sales_order_no ?? ""),
      },
      {
        title: "Customer Name",
        dataIndex: "customer_full_name",
        sorter: (a, b) => (a?.customer_full_name ?? "").localeCompare(b?.customer_full_name ?? ""),
      },

      {
        title: "Invoice Amount",
        dataIndex: "total_sales_order_amount",
        sorter: (a, b) => (a?.total_sales_order_amount ?? 0) - (b?.total_sales_order_amount ?? 0),
        render: (record) => <span>{formatCustomNumber(record)}</span>,
      },
      {
        title: "Status",
        dataIndex: "sales_order_status_name",
        sorter: (a, b) => (a?.sales_order_status_name ?? "").localeCompare(b?.sales_order_status_name ?? ""),
      },
    ],
    []
  );

  // Set table data from global state
  useEffect(() => {
    mountRef.current = true;
    setTableData(driverAssignData["so_not_shipped"] || []);
    return () => {
      mountRef.current = false;
    };
  }, [driverAssignData]);

  // Handle session-based reload
  // useEffect(() => {
  //   if (sessionStorage.getItem("reloadPage") === "true") {
  //     sessionStorage.removeItem("reloadPage");
  //     getDriverAssignListApi();
  //   }
  // }, []);

  useEffect(() => {
    if (driverAssignData["so_not_shipped"]?.length > 0) return;
    getDriverAssignListApi();
  }, []);


  // Fetch sales order list with abortable request
  const getDriverAssignListApi = useCallback(async () => {
    const abortController = new AbortController();
    try {
      const response = await driverAssignService.getDriverAssignList({ signal: abortController.signal });
      if (mountRef.current && response?.data !== undefined) {
        setDriverAssignData(response.data);
      }
    } catch (err) {
      if (!abortController.signal.aborted) console.error(err);
    }
    return () => abortController.abort();
  }, [setDriverAssignData]);

  // Unified filter function
  const applyFilter = useCallback(
    (filterValue) => {
      const fullList = driverAssignData["so_not_shipped"] || [];
      if (Number(filterValue) === 0) {
        setTableData(fullList);
      } else {
        const filtered = fullList.filter(
          (item) => item.sales_order_status_id === Number(filterValue)
        );
        setTableData(filtered);
      }
    },
    [driverAssignData]
  );


  const selectedTableItems = useCallback((itemList) => {
    setItemSelected(itemList);
  }, []);


  // const searchByDate = useCallback(async () => {
  //   const formData = getValues();
  //   try {
  //     const response = await salesService.getSalesOrderListByDate(formData);
  //     if (response?.data?.length) {
  //       setTableData(response.data);
  //     } else {
  //       showToast("No result found", "");
  //       setTableData([]);
  //     }
  //   } catch (err) {
  //     showToast("Error", "error");
  //   }
  // }, [getValues, showToast]);

  const handleRowClick = useCallback(
    (data) => {
      const id = data["sales_order_ref_no"];
      navigate(`/${currModuleId}/${currModuleName}/sales-order/details/${id}`);
    },
    [currModuleId, currModuleName, navigate]
  );



  const onClearInput = () => {
    setSearchText("");
    setTableData(driverAssignData["so_not_shipped"] || []);

  }



  const handleSearch = (text) => {
    setSearchText(text);

    if (text.trim() === "") {
      setTableData(driverAssignData["so_not_shipped"] || []);
      return;
    }

    const searchTerm = text.toLowerCase();
    const filtered = (driverAssignData["so_not_shipped"] || []).filter(credit =>
      Object.values(credit).some(value =>
        value?.toString().toLowerCase().includes(searchTerm)
      )
    );
    setTableData(filtered);
  };

  const handleSave = async () => {
    let option = '32';
    const driverId = getValues('driver_id');
    if (!driverId) {
      showToast('Please select a driver', 'error');
      return;
    }


    if (itemSelected.length === 0) {
      return showToast('At least one Sales Order should be selected', 'error');
    }



    const confirm = await myPromiseModal({
      title: `Process driver assignment`,
      body: `You are about to assign driver to ${itemSelected.length} sales order(s). Please select the pickup date and time.`,
      showInput: false,
      showDate: true

    });
    if (!confirm?.date) {
      showToast('Please select the pickup date and time', 'error');
      return;
    }
    //  return;
    if (!confirm?.decision) return;

    const xmlItems = itemSelected
      .map(item => `<a><refno>${item.sales_order_ref_no}</refno> </a>`)
      .join('');

    const payload = new FormData();
    payload.set('option', option);
    payload.set('delivery_user_id', getValues('driver_id'));// The is the selected driver id from the dropdown (driverAssignData.driver_list)
    payload.set('pickup_date', confirm.date); // the is the pick up date and time.
    payload.set('xml_string_refno', `<root>${xmlItems}</root>`);

    try {
      const res = await driverAssignService.submitDriverAssign(payload);
      const response = httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);

      if (response.message_id === 1) {
        showToast(response.message_text || 'Driver assignment successful!', 'success');
        //  sessionStorage.setItem('reloadPage', 'true');
        getDriverAssignListApi();
        setItemSelected([]);

        //  navigate(-1);
      } else {
        showToast(response.message_text || 'Failed to save', 'error');
      }
    } catch (err) {
      // showToast('Error submitting form', 'error');
    }
  };


  return (
    <>

      <div className="mt-6 md:flex items-end justify-between space-y-3 md:space-y-0">
        <div className="flex items-center space-x-2">

          <Tooltip title="Reload">
            <div
              onClick={getDriverAssignListApi}
              className="h-fit w-fit p-2 rounded-full cursor-pointer hover:bg-gray-200 active:bg-gray-300"
            >
              <IoMdRefresh className="h-[20px] w-[20px] text-gray-600" />
            </div>
          </Tooltip>
        </div>

        {/* <div className="flex flex-row items-end space-x-2">
          <div>
            <span className="ml-1 text-sm">From Date:</span>
            <input
              defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
              {...register("from_date")}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>
          <div>
            <span className="ml-1 text-sm">To Date:</span>
            <input
              {...register("to_date")}
              defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>
          <div>
            <button
              onClick={searchByDate}
              type="button"
              className="text-sm text-white px-3 bg-blue-500 rounded py-2.5"
            >
              Search
            </button>
          </div>
        </div> */}
        <div className="text-sm text-white px-3 bg-green-500 rounded py-2.5">
          Selected items {itemSelected?.length}
        </div>


        <div className="flex flex-row items-end space-x-2">
          <div>
            <span className="ml-1 text-sm">Driver:</span>
            <select
              {...register("driver_id")}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 py-2 rounded outline-none focus:ring-blue-300"
            >
              <option value="">Select Driver</option>
              {driverAssignData?.driver_list?.map((driver) => (
                <option key={driver.user_id} value={driver.user_id}>
                  {driver.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <button
              onClick={handleSave}
              type="button"
              className="text-sm text-white px-3 bg-blue-500 rounded py-2.5"
            >
              Assign Driver
            </button>
          </div>
        </div>





      </div>

      {/* Start of search */}
      <div className="flex justify-center mt-4">
        <div className="flex flex-col w-full md:w-1/3">
          <input
            type="text"
            placeholder="Search in table"
            value={searchText}
            onKeyDown={(e) => {
              if (e.key === 'Backspace') {
                onClearInput();
              }
            }}
            onChange={(e) => handleSearch(e.target.value)}
            className="bg-white ring-1 ring-gray-200 w-full pl-3 py-2 rounded outline-none focus:ring-blue-300"
          />
        </div>
      </div>
      {/* End of search */}

      <section className="mt-5">
        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={tableData}
          allowCheckBox={true}
          setSelectedRows={selectedTableItems}
          rowKey={(record) => record.sales_order_ref_no}
          handleRowClick={handleRowClick}
        />
      </section>
    </>
  );
};

export default React.memo(DriverAssignPage); // Memoize component